import debounce from './debounce'

export default {
  created () {
    this.setRem()
  },
  methods: {
    setRem () {
      let setRem = () => {
        let min = Math.min(100 * document.documentElement.clientHeight / 1512, 100 * document.documentElement.clientWidth / 3840)
        document.documentElement.style.fontSize = min + 'px'
      }
      window.addEventListener('resize', debounce(setRem, 200))
      setRem()
    },
    debounce
  }
}
